/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentProviderStatusResponse
 */
export interface PaymentProviderStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentProviderStatusResponse
     */
    available: boolean;
}

/**
 * Check if a given object implements the PaymentProviderStatusResponse interface.
 */
// @ts-ignore
export function instanceOfPaymentProviderStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "available" in value;

    return isInstance;
}

// @ts-ignore
export function PaymentProviderStatusResponseFromJSON(json: any): PaymentProviderStatusResponse {
    return PaymentProviderStatusResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function PaymentProviderStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentProviderStatusResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'available': json['available'],
    };
}

// @ts-ignore
export function PaymentProviderStatusResponseToJSON(value?: PaymentProviderStatusResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'available': value.available,
    };
}

